// extracted by mini-css-extract-plugin
export default {"prefCardModalOverlay":"Eh04M","prefCardModal":"kQqQE","modalContentWrapper":"_0zKJu","buttonsWrapper":"OP39X","button":"JY0ul"};